import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import ModalPesanStore from '../../components/ModalPesanStore'
import qs from 'qs'
import Paging from '../../components/Paging'
import FormDropdown from '../../components/FormDropdown';
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";


class Dataujian extends Component {

    constructor() {
        super();
        this.state = {
            data_siswaKelas   : [],
            dataSisAll: [],
            dataSisNonUjian: [],
            dataKelasAsal : [],
            dataKelasTujuan : [],
            data_tahun_ajar:[],
            data_siswaKelas_tujuan : [],
            user_id : "",
            siswa_id:"",
            tahun_ajar:"",
            thn_ajar_value:"",
            kelas_id : "",
            kelas_id_tujuan:"",
            thn_ajar_id_oll:"",
            thn_ajar_id_new:"",
            kelas_nama : "",
            pageCount    : 0,
            currentPage  : 0,
            pageCountTujuan    : 0,
            currentPageTujuan  : 0,
            isLoading    : false,
            isModalShow  : false,
            isModalShowNon  : false,
            isModalShowDelete  : false,
            checked:false,
            selected:[],
            selectedNon:[],
            partRemed : [],
            partRemedNon : [],
            isAll:false,
            isModalPesanShow:false,
            value: null
        }

        this.toggleModalDelete         = this.toggleModalDelete.bind(this)
        this.toggleModal              = this.toggleModal.bind(this)
        this.toggleModalPesan              = this.toggleModalPesan.bind(this)
        this.toggleModalNon              = this.toggleModalNon.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handleSubmitButton = this.handleSubmitButton.bind(this)
        this.handleSubmitButtonNon = this.handleSubmitButtonNon.bind(this)
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
        this.handleSelectedChanged = this.handleSelectedChanged.bind(this)
        this.handleSelectedChangedNon = this.handleSelectedChangedNon.bind(this)
    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    toggleModalPesan() {
        this.setState({ isModalPesanShow: ! this.state.isModalPesanShow })
    }

    toggleModalNon() {
        this.setState({ isModalShowNon: ! this.state.isModalShowNon })
    }

    toggleModalDelete() {
        this.setState({ isModalShowDelete: ! this.state.isModalShowDelete })
    }

    handleSubmitDeleteButton() {

        const params = qs.stringify({
            kelas_id_asal:this.state.kelas_id,
            siswa_id:this.state.siswa_id,
            user_id:localStorage.SISMART_USER_ID

        })

        axios({
            method: 'post',
            url: '/naik_kelas/delete?' + params
        })
            .then(response => {

                Alert.success("Data berhasil dihapus",{
                    position: 'bottom-right'
                });
                this.loadDataTujuan();
                this.loadData();
                this.state.isModalShowDelete=false;


                return;
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!",{
                    position: 'bottom-right'
                })
            })
    }

    handleSubmitButton() {

        const params = qs.stringify({
            kelas_id:this.state.kelas_id,
            allow_exam:'0',
            user_id:localStorage.SISMART_USER_ID,
            siswa_selected:this.state.partRemed

        })

        const url ='/siswa/update_ujian';

        axios
            .post(url, params)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message,{
                        position: 'bottom-right'
                    });

                    this.loadData();
                    this.state.isModalShow=false;
                    this.state.partRemed=[];
                    this.selected=[];

                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {

                            this.state.isModalShow=false;
                            this.selected=[];
                            this.state.partRemed=[];
                            Alert.error(item);

                            return true;
                        });
                    } else {

                        this.state.isModalShow=false;
                        this.selected=[];
                        this.state.partRemed=[];
                        Alert.error(result.message,{
                            position: 'bottom-right'
                        });
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log("ERROR", error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isButtonLoading: false });
            });
        this.setState({ showformAdd: false });
    }

    handleSubmitButtonNon() {

        const params = qs.stringify({
            kelas_id:this.state.kelas_id,
            allow_exam:'1',
            user_id:localStorage.SISMART_USER_ID,
            siswa_selected:this.state.partRemedNon

        })

        const url ='/siswa/update_ujian';

        axios
            .post(url, params)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message,{
                        position: 'bottom-right'
                    });

                    this.loadData();
                    this.state.isModalShowNon=false;
                    this.state.partRemedNon=[];
                    this.selected=[];

                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {

                            this.state.isModalShowNon=false;
                            this.selected=[];
                            this.state.partRemedNon=[];
                            Alert.error(item,{
                                position: 'bottom-right'
                            });

                            return true;
                        });
                    } else {

                        this.state.isModalShowNon=false;
                        this.selected=[];
                        this.state.partRemedNon=[];
                        Alert.error(result.message,{
                            position: 'bottom-right'
                        });
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log("ERROR", error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isButtonLoading: false });
            });
        this.setState({ showformAdd: false });
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handlePageClickTujuan(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPageTujuan: selected }, () => {
            this.loadDataTujuan();
        });
    }

    loadDataKelasAsal(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelasAsal: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            kelas_id : this.state.kelas_id
        })

        axios({
            method: 'post',
            url: '/siswa_data_ujian?' + params
        })
            .then((response) => {

                const result = response.data

                if (result.success === true) {

                    this.setState({
                        data_siswaKelas : result.data.data,
                        pageCount  : result.data.last_page,
                        isLoading  : false
                    })
                    this.loadDataTujuan()
                }
                else {

                    Alert.error(result.message,{
                        position: 'bottom-right'
                    })
                    this.setState({ isLoading: false })
                }
            })
            .catch((error) => {
                console.log(error)
                this.selected=[]
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!",{
                    position: 'bottom-right'
                })
            })
    }

    handleSelectedChanged(partRemed) {
        this.setState({partRemed});
    }
    handleSelectedChangedNon(partRemedNon) {
        this.setState({partRemedNon});
    }

    loadDataTujuan() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPageTujuan + 1,
            kelas_id : this.state.kelas_id
        })

        axios({
            method: 'post',
            url: '/siswa_data_non_ujian?' + params
        })
            .then((response) => {

                const result = response.data

                if (result.success === true) {
                    this.setState({
                        data_siswaKelas_tujuan : result.data.data,
                        pageCountTujuan : result.data.last_page,
                        isLoading  : false
                    })
                    this.selected=[]
                }
                else {

                    Alert.error(result.message)
                    this.setState({ isLoading: false })
                    this.selected=[]
                }
            })
            .catch((error) => {
                console.log(error)
                this.selected=[]
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    componentDidMount() {
        this.loadData();
        this.loadDataKelasAsal();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.kelas_id !== this.state.kelas_id ) {
            this.loadData(),
                this.loadDataTujuan(),
                this.setState({
                    isAll: false,
                    partRemed   :[]
                });
        }
    }

    render () {
        const dataSisAll = this.state.data_siswaKelas.map(item => ({
            value: item.siswa_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const {partRemed} = this.state;

        const dataSisNonUjian = this.state.data_siswaKelas_tujuan.map(item => ({
            value: item.siswa_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const {partRemedNon} = this.state;
        return (
            <div className="col-sm-12">
                <ModalPesanStore
                    isShow={this.state.isModalPesanShow}
                    toggleModalPesan ={this.toggleModalPesan}
                    modalHeaderText="Pesan Blokir"
                    modalBodyText={"Pesan blokir ujian siswa"}
                    userId ={this.state.user_id}
                    modalSubmitText="Update" />

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitButton}
                    modalHeaderText="Data Siswa"
                    modalBodyText={"Konfirmasi data ujian siswa"}
                    modalSubmitText="Ya" />

                <CustomModal
                    isShow={this.state.isModalShowNon}
                    toggleModal={this.toggleModalNon}
                    handleSubmit={this.handleSubmitButtonNon}
                    modalHeaderText="Data Siswa"
                    modalBodyText={"Konfirmasi data ujian siswa"}
                    modalSubmitText="Ya" />


                <CustomModal
                    isShow={this.state.isModalShowDelete}
                    toggleModal={this.toggleModalDelete}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-header">
                        Data Siswa Ujian
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-6">
                                <div className="card">
                                    <div className="card-header">
                                        Filter Kelas
                                    </div>
                                    <div className="card-body">
                                        <FormDropdown
                                            items={this.state.dataKelasAsal}
                                            onChange={this.handleChange}
                                            value={this.state.kelas_id.toString()}
                                            placeholder={"Pilih Kelas"}
                                            name="kelas_id"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="form-group row">
                            <div className="col-md-6 ">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.data_siswaKelas.length == 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Siswa Bisa Ujian
                                                    <button
                                                        type="button"
                                                        className="btn btn-md btn-primary"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        style={{ float: "right" }}
                                                        onClick={() => {
                                                            this.toggleModal();
                                                        }}
                                                    >
                                                    {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                                </button>

                                                </div>

                                                <SelectPanel
                                                    options={dataSisAll}
                                                    onSelectedChanged={this.handleSelectedChanged}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partRemed}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div><div className="col-md-6">
                            {
                                this.state.isLoading ? "Memuat Data..." : (
                                    this.state.data_siswaKelas_tujuan.length === 0 ? "Data Kosong..." : (
                                        <div className='card'>
                                            <div className="card-header">
                                                Data Siswa Tidak Bisa Ujian
                                                <button
                                                    type="button"
                                                    className="btn btn-md btn-danger"
                                                    disabled={this.state.isButtonLoading && "disabled"}
                                                    style={{ float: "right" }}
                                                    onClick={() => {
                                                        this.toggleModalNon();
                                                    }}
                                                >
                                                    {this.state.isButtonLoading ? "Loading" : "Hapus"}
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        this.toggleModalPesan();
                                                        this.setState({
                                                            userId: this.state.user_id
                                                        });
                                                    }}
                                                    className="btn btn-danger btn-md"
                                                    style={{ float: "right",marginRight:'10px' }}
                                                    title="Pesan Blokir">
                                                    <i className="fa fa-envelope" title="Pesan Blokir"></i> Pesan Blokir
                                                </button>

                                            </div>

                                            <SelectPanel
                                                options={dataSisNonUjian}
                                                onSelectedChanged={this.handleSelectedChangedNon}
                                                hasSelectAll
                                                focusIndex={1}
                                                selected={partRemedNon}
                                                disableSearch={false}
                                            />
                                        </div>
                                    )
                                )
                            }
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Dataujian;



// WEBPACK FOOTER //
// ./src/views/Users/Dataujian.js